import { createVueViewComponent } from "@/shared/utils/vue";

import { EmailConfirm, PasswordReset } from "@/app/PasswordReset";
import { TastierClient } from "@/app/TastierClient";

// import css
import "./../../assets/styles/scss/app.scss";
import "./../../assets/styles/scss/primevue/themes/saga/saga-green/theme.scss";
// import components
import App from "./App.vue";

// todo: use in global scope
(window as any).Tastier = {
    TastierClient,
    EmailConfirm,
    PasswordReset,
};

createVueViewComponent(App, {}, document.querySelector("#vue-app")!);
